<template>
  <div>
    <VTableLocal
      :iconHeader="null"
      :items="displayedUsers"
      :isSearchable="false"
      :isSelectable="false"
      :headers="tableHeaders"
      :showRowIcon="true"
      disablePagination
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTableLocal from '@/components/shared/content-views/VTableLocal';

export default {
    components: {
        VTableLocal,
    },
    props: {
        teamId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            loading: false,
            roles: [],
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'site',
        ]),
        tableHeaders() {
            return [
                {
                    text: this.$t('forms.labels.role'),
                    value: 'name',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.activeUser'),
                    value: 'activeUsers',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.inactiveUser'),
                    value: 'inActiveUsers',
                    sortable: false,
                },
                {
                    text: '',
                    value: '',
                    sortable: false,
                },
                {
                    text: '',
                    value: '',
                    sortable: false,
                },
            ];
        },
        displayedUsers() {
            return this.roles.length ? this.roles.map(role => ({
                ...role,
                name: this.$t(`roles.${role.key}`),
            })) : [];
        },
    },
    async created() {
        await this.loadData();
    },
    methods: {
        async loadData() {
            const { data } = await this.$rq.getUsersCountByRole(this.teamId);
            this.roles = data;
        },
    },
};
</script>
<style lang="scss" scoped>
</style>
